import helper from '@/libs/forms';
import schemaHelper from '@/components/profile/sections/tabs/financial/resources/schemaHelper';


const insuranceFields = () => {
  const defaultFields = [
    helper.currency('Face Amount', 'amount', true),
    helper.simpleInput('text', 'Insurance Company', null, 'company', true),
    helper.simpleInput('text', 'Beneficiaries', null, 'beneficiaries', true),
    helper.currency('Cash Surrender Value', 'surrender', true),
    helper.boolRadio(
      'Do you have a loan on this life insurance?',
      'loan',
      true,
    ),
  ];

  const additionalFields = schemaHelper.generalFields();
  additionalFields[0].model = 'loanAmount';
  schemaHelper.setVisibility(schemaHelper.boolFieldVisibility, additionalFields, 'loan');

  return defaultFields.concat(additionalFields);
};


export default { fields: insuranceFields() };



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/lifeInsurances.js